(() => {
  //loading
  const intro = document.querySelector(".intro");
  const imgs = intro.querySelectorAll("img");

  let loadedCount = 0;

  //5病後に強制表示
  let timeoutId = setTimeout(() => {
    finishLoading();
  }, 5000);

  //画像読み込みしたら
  function onImageLoad() {
    loadedCount++;
    if (loadedCount === imgs.length) {
      finishLoading();
    }
  }

  //画像読み込み判定
  imgs.forEach((img) => {
    if (img.complete) {
      onImageLoad();
    } else {
      img.addEventListener("load", onImageLoad);
    }
  });

  //読み込みが完了したら
  function finishLoading() {
    const loading = document.getElementById("loading");
    const content = document.getElementById("content");

    if (!loading || loading.style.display === "none") return;

    loading.style.transition = "opacity 0.5s";
    loading.style.opacity = 0;

    setTimeout(() => {
      loading.style.display = "none";
      content.style.display = "block";
    }, 500);

    clearTimeout(timeoutId);
  }

  //////////////////////////////////////////////////////
  //画像リスト設定
  const items = document.querySelectorAll(".pageCatalog__item");
  const modal = document.getElementById("popup");
  const modalImg = document.querySelector(".pageCatalog__popup__img img");
  const modalText = document.querySelector(".pageCatalog__popup__text__inner");
  const modalClose = document.querySelector(".pageCatalog__popup__closeBtn");
  const modalInner = document.querySelector(".pageCatalog__popup__inner");

  // 前回のフォーカス対象保存用
  let lastFocusedElement = null;

  items.forEach((item, index) => {
    const img = item.querySelector("img");
    const button = item.querySelector("button");
    const hiddenText = item.querySelector(".pageCatalog__data");

    // button に aria-label を付与（画像に alt がない場合用）
    if (!button.hasAttribute("aria-label")) {
      const firstTitle = hiddenText.querySelector("h3");
      button.setAttribute("aria-label", firstTitle?.textContent?.trim() || `商品${index + 1}`);
    }

    button.addEventListener("click", () => {
      lastFocusedElement = document.activeElement;

      modalImg.src = img.src;
      modalText.innerHTML = hiddenText.innerHTML;

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");

      // モーダルにフォーカスを移す
      modalInner.focus();
    });
  });

  function closeModal() {
    modal.classList.remove("is-active");
    modal.setAttribute("aria-hidden", "true");
    modalImg.src = "";

    // フォーカスを元に戻す
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  modalClose.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // ESCキーでモーダルを閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-active")) {
      closeModal();
    }
  });

  //moreボタン
  const list = document.querySelector(".pageCatalog__list");
  const moreBtn = document.querySelector(".pageCatalog__more");
  moreBtn.addEventListener("click", () => {
    list.classList.add("is-show");
    moreBtn.remove();
  });

  //カタログのヘッダー要素
  const menuToggle = document.getElementById('catalog-menu-toggle');
  const menuPanel = document.getElementById('catalog-menupanel');

  menuToggle.addEventListener('click', () => {
    const isActive = menuToggle.classList.toggle('active');
    menuPanel.classList.toggle('active');

    // アニメーションを戻す（万一scrollでno-transitionが残っていたら除去）
    if (menuPanel.classList.contains('no-transition')) {
      menuPanel.classList.remove('no-transition');
    }
  });

  // スクロール時にメニューを即時で閉じる
  window.addEventListener('scroll', () => {
    if (menuPanel.classList.contains('active')) {
      // 一時的にtransitionを無効化
      menuPanel.classList.add('no-transition');
      menuPanel.classList.remove('active');
      menuToggle.classList.remove('active');

      // 次のリペイント後（すぐ）にno-transitionクラスを除去して戻す
      requestAnimationFrame(() => {
        menuPanel.classList.remove('no-transition');
      });
    }
  });
})();
